export default {"src":"/_next/static/media/dollar-badge.431fea94.svg","height":127,"width":128,"blurWidth":0,"blurHeight":0};